import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { InquiryFormState, RootState } from '../types';

const namespaced: boolean = true;

export const state: InquiryFormState = {
	inquiryForm: null,
	inquiryFormRequests: [],
	selectedInquiryFormRequest: null,
	filters: {
		orderBy: 'created_at'
	},
	currentPage: 1,
	totalPages: 1
};

export const InquiryFormModule: Module<InquiryFormState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default InquiryFormModule;
